<template>
    <overlay-modal ref="overlayModal" width="65%">
        <template v-slot:header>
            <div class="d-flex justify-content-between">
                <div>
                    <h6 class="d-flex text-uppercase text-primary">
                        <div class="type-info">
                            <span>{{label}}</span>
                        </div>
                    </h6>
                    <h4 class="cursive">{{name}}</h4>
                </div>
            </div>
        </template>
        <template>
            <div class="modal-tour-detail">
                <div>
                    <big-carousel :images="images" class="my-3"/>
                    <div v-if="!hideForm" class="mb-3">
                        <h5 class="cursive">Scegli il giorno di partenza {{isCamereRequested ? 'le camere' : ''}} {{isVoloRequested ? 'e il volo' : ''}}</h5>
                        <div class="row">
                            <div class="col-12 col-md-3 mt-2">
                                <CustomDatePicker placeholder="SCEGLI UNA DATA" v-model="partenza" :disabledDates="disabledDates"/>
                            </div>
                            <div v-if="isCamereRequested" class="col-12 col-md-4 mt-2">
                                <CamereSelector v-model="camere"/>
                            </div>
                            <div v-if="isVoloRequested" class="col-12 col-md-5 mt-2">
                                <v-select class="form-control" v-model="aereoporto" placeholder="Aereoporto di partenza" :options="list"/>
                            </div>
                            <div class="col-12 col-md-3 mt-2">
                                <button id="procediTour" :disabled="isDisabled" class="btn btn-primary px-4 w-100" @click="onSelectProcedi()">procedi</button>
                            </div>
                        </div>
                    </div>
                    <tabs class="mb-3" v-if="partenza">
                        <tab title="Descrizione">
                            <div class="mb-3">
                                <p class="text-justify" v-html="description"></p>
                            </div>
                            <div>
                                <CustomGoogleMap ref="mainMap" :markers="markers" height="300px"/>
                            </div>
                        </tab>
                        <tab title="Itinerario" @click="onClickItinerario">
                            <div class="row no-gutters mb-4 border-bottom" v-for="(item, index) in dayByDay" :key="index">
                                <div class="col-12 col-md-4 pr-md-4">
                                    <small-carousel :images="item.imagesUrl" class="mb-3"/>
                                </div>
                                <div class="col-12 col-md-8">
                                    <div class="mb-2">
                                        <h6 v-if="item.kilometers" class="mb-0">{{index + 1 }}° giorno ({{item.kilometers}}) - {{item.descriptionTitle}}</h6>
                                        <h6 v-else class="mb-0">{{index + 1 }}° giorno - {{item.descriptionTitle}}</h6>
                                        <img src="../../../../../assets/images/svg/black/icone_durata.svg" height="12px"/>
                                        <small>{{item.date}}</small>
                                    </div>
                                    <p class="text-justify">{{item.description}}</p>
                                    <div v-if="item.categoryDescriptions.length > 0">
                                        <table class="table" style="font-size: 0.75rem" v-if="item.categoryDescriptions.some(cat => cat.hotels.length>0)" >
                                            <thead>
                                            <tr>
                                                <th>Categoria</th>
                                                <th>Sistemazione</th>
                                                <th>Trattamento</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(cat, index) in item.categoryDescriptions" :key="index" >
                                                <td><p class="mb-0">{{cat.category}}</p></td>
                                                <td><p class="mb-0">{{hotelNames(cat.hotels)}}</p></td>
                                                <td><p class="mb-0">{{cat.treatment}}</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <table class="table" style="font-size: 0.75rem" v-else>
                                            <thead>
                                            <tr>
                                                <th width="50%">Categoria</th>
                                                <th width="50%">Trattamento</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr v-for="(cat, index) in item.categoryDescriptions" :key="index" >
                                                <td><p class="mb-0">{{cat.category}}</p></td>
                                                <td><p class="mb-0">{{cat.treatment}}</p></td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </tab>
                        <tab title="Specifiche">
                            <div class="mb-3">
                                <h4>Dettagli</h4>
                                <table class="table table-striped">
                                    <tbody>
                                    <tr v-if="detail.line">
                                        <td style="width:30%">
                                            <b>Tipologia di viaggio</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0">{{detail.line}}</p>
                                        </td>
                                    </tr>
                                    <tr v-if="detail.language">
                                        <td style="width:30%">
                                            <b>Lingua</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0">{{detail.language}}</p>
                                        </td>
                                    </tr>
                                    <tr v-if="detail.treatment">
                                        <td style="width:30%">
                                            <b>Trattamento</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0">{{detail.treatment}}</p>
                                        </td>
                                    </tr>
                                    <tr v-if="detail.meansOfTransportation">
                                        <td style="width:30%">
                                            <b>Mezzi di trasporto</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0" v-for="(item, index) in detail.meansOfTransportation" :key="index">
                                                {{item}}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr v-if="detail.peculiarities">
                                        <td style="width:30%">
                                            <b>Peculiarità</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0">{{detail.peculiarities}}</p>
                                        </td>
                                    </tr>
                                    <tr v-if="detail.countriesName">
                                        <td style="width:30%">
                                            <b>Nazione</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0"  v-for="(item, index) in detail.countriesName" :key="index">
                                                {{item}}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr v-if="detail.categories">
                                        <td style="width:30%">
                                            <b>Categorie</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0"  v-for="(item, index) in detail.categories" :key="index">
                                                {{item}}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr v-if="detail.guide">
                                        <td style="width:30%">
                                            <b>Accompagnatore</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0">{{detail.guide}}</p>
                                        </td>
                                    </tr>
                                    <tr v-if="detail.accomodation">
                                        <td style="width:30%">
                                            <b>Sistemazione</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0">{{detail.accomodation}}</p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="mb-3">
                                <h4>Voli</h4>
                                <table class="table table-striped">
                                    <tbody>
                                    <tr>
                                        <td style="width:30%">
                                            <b>Voli inclusi</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0">{{detail.flightIncluded ? 'si' : 'no'}}</p>
                                        </td>
                                    </tr>
                                    <tr v-if="detail.departure">
                                        <td style="width:30%">
                                            <b>Partenza</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0">{{detail.departure}}</p>
                                        </td>
                                    </tr>
                                    <tr v-if="detail.departureAirports">
                                        <td style="width:30%">
                                            <b>Aereoporti in partenza</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0"  v-for="(item, index) in detail.departureAirports" :key="index">
                                                {{item}}
                                            </p>
                                        </td>
                                    </tr>
                                    <tr v-if="detail.airlines">
                                        <td style="width:30%">
                                            <b>Compagnie aeree</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0"  v-for="(item, index) in detail.airlines" :key="index">
                                                {{item}}
                                            </p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="mb-3">
                                <h4>Pacchetto</h4>
                                <table class="table table-striped">
                                    <tbody>
                                    <tr>
                                        <td style="width:30%">
                                            <b>La quota comprende</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0" v-html="toBrTag(detail.priceIncludes)"></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width:30%">
                                            <b>La quota non comprende</b>
                                        </td>
                                        <td style="width:70%">
                                            <p class="m-0" v-html="toBrTag(detail.priceDoesNotInclude)"></p>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </tab>
                        <tab title="Note">
                            <table v-if="!isMobile" class="table table-striped">
                                <tbody>
                                <tr v-for="(item, index) in notes" :key="index">
                                    <td style="width:30%">
                                        <b>{{item.title}}</b>
                                    </td>
                                    <td style="width:70%">
                                        <p class="m-0"  v-html="item.text"></p>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <div v-else>
                                <div v-for="(item, index) in notes" :key="index">
                                    <b>{{item.title}}</b>
                                    <p class="mb-3 border-top pt-1" v-html="item.text"></p>
                                </div>
                            </div>
                        </tab>
                    </tabs>
                </div>
            </div>
        </template>
    </overlay-modal>
</template>

<script>
import {mapGetters} from 'vuex'
import OverlayModal from '../../../../modals/OverlayModal'
import {isSameDate, tourName, toBrTag} from '../../../../../utils/helper'
import CustomGoogleMap from '../../../common/CustomGoogleMap'
import {middleDateFormatter, toDateFromServer} from '../../../../../utils/formatter'
import CustomDatePicker from '../../../common/CustomDatePicker'
import CamereSelector from '../../../common/CamereSelector'
import BigCarousel from '../../../common/BigCarousel'
import SmallCarousel from '../../../common/SmallCarousel'
import AnalyticEvents from '../../../../common/AnalyticEvents'
import MobileDetector from '../../../../common/MobileDetector'
import ConfigUtils from '../../../../utils/ConfigUtils'

export default {
  name: 'ModalTourDetail',
  mixins: [AnalyticEvents, MobileDetector, ConfigUtils],
  components: {SmallCarousel, BigCarousel, CamereSelector, CustomDatePicker, CustomGoogleMap, OverlayModal},
  props: {
    value: {
      type: Object,
      value: null
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isHomePage: {
      type: Boolean,
      default: false
    },
    isCamereRequested: {
      type: Boolean,
      default: false
    },
    hideForm: {
      type: Boolean,
      value: false
    }
  },
  data: function () {
    return {
      aereoporto: null,
      partenza: null,
      camere: [{
        adults: 2, childs: []
      }],
      change: false
    }
  },
  computed: {
    config () {
      return this.value.config ? this.value.config : this.value.anagrafica.config
    },
    isDisabled () {
      if (this.isVoloRequested) {
        return this.aereoporto === null
      }
      return false
    },
    label () {
      return (this.config && this.config.label) ? this.config.label : ''
    },
    isHighlight () {
      return this.config.isHighlight ? this.config.isHighlight : false
    },
    isVoloRequested () {
      return !this.detailResponse.detail.flightIncluded
    },
    list () {
      return this.getTypesAereoporti().map(function (item) {
        return {label: item.name, value: item.id}
      })
    },
    paginationStyle () {
      return this.images.length > 1 ? 'simple with-bottom-area' : 'simple'
    },
    anagrafica () {
      return this.value.anagrafica
    },
    detailResponse () {
      return this.value.detailResponse ? this.value.detailResponse : this.value.detailResponses[0]
    },
    detail () {
      return this.detailResponse.detail
    },
    element () {
      return this.value.element
    },
    flights () {
      return this.detail.flight
    },
    images () {
      return this.detail.imagesUrl
    },
    dayByDay () {
      const list = this.detail.dayByDay.length > 0 ? this.detail.dayByDay : this.anagrafica.detailResponse.detail.dayByDay
      const partenzaTour = this.$store.getters.isGiornoSuccessivoObbligatorio ? this.$moment(this.partenza).add(1, 'days').toDate() : this.partenza
      return list.map((item, index) => {
        const date = middleDateFormatter(this.$moment(partenzaTour).add(index, 'days'))
        return {...item, date}
      })
    },
    name () {
      return tourName(this.detail.name)
    },
    description () {
      return toBrTag(this.detail.description)
    },
    date () {
      return middleDateFormatter(toDateFromServer(this.detail.departureDate.date))
    },
    notes () {
      return this.detailResponse.notes.filter(item => item.web === true)
    },
    markers () {
      if (this.element && this.element.places) {
        return this.element.places.filter(item => (item.order > 0 && item.coordinate)).map(item => {
          return {title: item.name, lat: item.coordinate.latitude, lng: item.coordinate.longitude}
        })
      }
      let list = []
      this.dayByDay.forEach(day => {
        day.places.forEach(item => {
          if (item.coordinate && item.order > 0) {
            list.push({title: item.name, lat: item.coordinate.latitude, lng: item.coordinate.longitude})
          }
        })
      })
      return list
    },
    disabledDates: function () {
      if (!this.departureFutureDates) return []
      return {
        customPredictor: (date) => {
          const hasDate = this.departureFutureDates.some(item => {
            return isSameDate(date, item)
          })
          return !hasDate
        }
      }
    },
    departureFutureDates () {
      if (!this.element) {
        return []
      }
      const dates = this.element.departuresDatePrice.map(item => {
        return toDateFromServer(item.date.date)
      })
      return this.partenza == null ? dates : dates.filter(date => date.getTime() >= this.partenza.getTime())
    }
  },
  methods: {
    ...mapGetters(['getTour', 'getSearch', 'getTypesAereoporti', 'getTours']),
    toBrTag,
    open (partenza = null) {
      this.partenza = null
      this.$nextTick(() => {
        if (partenza != null) {
          this.partenza = this.$store.getters.isGiornoSuccessivoObbligatorio ? this.$moment(partenza).add(-1, 'days').toDate() : partenza
        } else {
          this.partenza = this.getSearch().partenza
        }
        this.$nextTick(() => {
          this.$refs.overlayModal.open()
        })
      })
    },
    close () {
      this.$refs.overlayModal.close()
    },
    onClickItinerario () {
      if (this.isHomePage) {
        this.trackHomeModaleTourItinerario()
      } else {
        if (this.getTour() !== null) { // sono nel wizzard
          this.trackModaleDettaglioTour()
        } else {
          this.trackResultModaleTourItinerario()
        }
      }
    },
    onSelectProcedi () {
      if (this.isHomePage) {
        this.trackHomeModaleTourProcedi()
      } else {
        this.trackResultModaleTourProcedi()
      }
      const tour = {...this.value}
      let search = {...this.getSearch(), partenza: this.partenza}
      if (this.isCamereRequested) search.camere = this.camere
      if (this.isVoloRequested) search.aereoporto = this.aereoporto
      this.$emit('select', {tour, search})
      this.close()
    },
    hotelNames (list) {
      if (!list || list.length === 0) return ''
      return list.map(h => h.location.name).reduce((t, c) => t + ' ' + c)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/tour-accompagnati/modals/ModalTourDetail.vue